export default __webpack_public_path__ + "static/discord-7079daa3a20752f953e233f582584e4c.png";